module.exports = __webpack_public_path__ + "files/344f1b646b453c91dbfae6d440c5bd05.png";